import { render, staticRenderFns } from "./messageEvent.vue?vue&type=template&id=0b23c6d4"
import script from "./messageEvent.vue?vue&type=script&lang=js"
export * from "./messageEvent.vue?vue&type=script&lang=js"
import style0 from "./messageEvent.vue?vue&type=style&index=0&id=0b23c6d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports